import { PlusOutlined } from '@ant-design/icons';
import styles from './AddButton.module.css';

interface AddButtonProps {
  onClick: () => void;
  label: string;
  className?: string;
}

/**
 * Dashed button with a "+" icon shown at insertion points.
 */
export function AddButton({ onClick, label, className }: AddButtonProps) {
  return (
    <button
      type="button"
      className={`${styles.button} ${className ?? ''}`}
      onClick={onClick}
    >
      <PlusOutlined className={styles.icon} />
      <span>{label}</span>
    </button>
  );
}
